import PerfectScrollbar from 'perfect-scrollbar';

if (window.matchMedia('(max-width: 768px)').matches) {
  const scroll = document.getElementById('js-scrollbar');
  const scrollbar = new PerfectScrollbar(scroll);
}
